module.exports = __webpack_public_path__ + "static/media/hit.5de93075.mp3";